import { uniq } from 'lodash';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import useDuplicateGroupIds from './useDuplicateGroupIds';

const useAvailableIndices = (question?: FlowsQuestion): number[] => {
  const answers = useFlowsSelector((state) => state.flows.answers);
  const duplicateGroupIds = useDuplicateGroupIds(question?.id || '');

  if (!question) return [];

  const answersWithGroupids = duplicateGroupIds
    .map((duplicateGroupId) =>
      answers
        .filter(({ index }) => index != null && index >= 0)
        .filter(({ groupId }) => groupId === duplicateGroupId)
        .filter(({ answer }) => answer != null && answer !== ''),
    )
    .flat();

  const uniqIndices: number[] = uniq(
    answersWithGroupids.map(({ index }) => index),
  ).filter((item) => item != null) as number[];

  return uniqIndices.sort((a, b) => a - b) || [];
};

export const useNextIndex = (question: FlowsQuestion): number => {
  const availableIndices = useAvailableIndices(question);

  return availableIndices.length > 0
    ? availableIndices[availableIndices.length - 1] + 1
    : 0;
};

export default useAvailableIndices;
